import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { emailValido, obrigatorio } from '@/shareds/regras'
import { auth } from '@/firebase'
import { alert } from '@/store'
import { normalizarEmail } from '../../../common/shareds/sharedEmail'


export default /*#__PURE__*/_defineComponent({
  __name: 'EsqueciSenha',
  setup(__props) {

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const email = ref('')
const carregando = ref(false)
const enviado = ref(false)

async function enviar() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		auth.languageCode = 'pt_BR'
		await auth.sendPasswordResetEmail(normalizarEmail(email.value), {
			url: `${window.location.origin}/login`,
		})
		enviado.value = true
	} catch (error) {
		// não revela se o e-mail existe
		if ((error as { code?: string }).code === 'auth/user-not-found') {
			enviado.value = true
			return
		}
		alert.setError('Não foi possível enviar o e-mail. Tente novamente mais tarde.')
	} finally {
		carregando.value = false
	}
}

return { __sfc: true,form, email, carregando, enviado, enviar, ContainerCenter, emailValido, obrigatorio }
}

})